import { useTranslation } from 'react-i18next';
import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';

const EMPTY_FILTERS = {
  order_number: '',
  status: '',
  min_amount: '',
  max_amount: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({ isOpen, toggle, applyFilters, filters = {} }) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({ ...EMPTY_FILTERS, ...filters });

  useEffect(() => {
    if (isOpen) {
      setFiltersData({ ...EMPTY_FILTERS, ...filters });
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return (
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      lockScroll={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('purchases.orderNumber')} </Label>
          <Input
            value={filtersData.order_number}
            onChange={(e) => setFiltersData({ ...filtersData, order_number: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.status')}: </Label>
          <Input
            type="select"
            value={filtersData.status}
            onChange={(e) => setFiltersData({ ...filtersData, status: e.target.value })}
          >
            <option value="">{t('common.all')}</option>
            <option value="draft">{t('common.draft')}</option>
            <option value="sent">{t('common.sent')}</option>
            <option value="approved">{t('common.approved')}</option>
            <option value="received">{t('common.received')}</option>
            <option value="canceled">{t('common.canceled')}</option>
          </Input>
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('sales.minAmount')}</Label>
          <Input
            type="number"
            value={filtersData.min_amount}
            onChange={(e) => setFiltersData({...filtersData, min_amount: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('sales.maxAmount')}</Label>
          <Input
            type="number"
            value={filtersData.max_amount}
            onChange={(e) => setFiltersData({...filtersData, max_amount: e.target.value})}
          />
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('common.addedAfter')} </Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({ ...filtersData, added_after: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')} </Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({ ...filtersData, added_before: e.target.value })}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{ marginBottom: '10px' }}>
          {t('common.applyFilters')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.clearFilters')}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;
